(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".vue3-star-ratings__wrapper[data-v-786b615e]{display:block;text-align:center}.vue3-star-ratings__wrapper *[data-v-786b615e]{box-sizing:border-box;margin:0;padding:0}.vue3-star-ratings[data-v-786b615e]{display:flex;justify-content:space-between;align-items:center;gap:1rem}.vue3-star-ratings button[data-v-786b615e]{border:0;display:flex;justify-content:center;align-items:center;border-radius:50%;cursor:pointer;outline:none}.vue3-star-ratings button svg[data-v-786b615e]{fill:currentColor}.stars[data-v-786b615e]{display:inline-block;position:relative;overflow:hidden}.stars-outer[data-v-786b615e],.stars-inner[data-v-786b615e]{height:inherit}.stars-inner[data-v-786b615e]{position:absolute;top:0;left:0;width:0;max-width:100%;min-width:0;white-space:nowrap;transition:.32s cubic-bezier(.075,.82,.165,1);overflow:hidden}.stars svg[data-v-786b615e]{display:inline-block;fill:currentColor;cursor:pointer}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { openBlock as n, createElementBlock as a, createElementVNode as u, defineComponent as R, ref as _, computed as w, onMounted as V, onBeforeUnmount as O, watch as L, normalizeStyle as l, createVNode as y, createCommentVNode as S, Fragment as C, renderList as k, createBlock as b, unref as E } from "vue";
const v = (t, i) => {
  const o = t.__vccOpts || t;
  for (const [r, g] of i)
    o[r] = g;
  return o;
}, M = {}, A = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 792.082 792.082"
}, N = /* @__PURE__ */ u("path", { d: "M317.896 396.024l304.749-276.467c27.36-27.36 27.36-71.677 0-99.037s-71.677-27.36-99.036 0L169.11 342.161c-14.783 14.783-21.302 34.538-20.084 53.897-1.218 19.359 5.301 39.114 20.084 53.897l354.531 321.606c27.36 27.36 71.677 27.36 99.037 0s27.36-71.677 0-99.036L317.896 396.024z" }, null, -1), p = [
  N
];
function I(t, i) {
  return n(), a("svg", A, p);
}
const W = /* @__PURE__ */ v(M, [["render", I]]), X = {}, j = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 792.082 792.082"
}, q = /* @__PURE__ */ u("path", { d: "M622.955 342.127L268.424 20.521c-27.36-27.36-71.677-27.36-99.037 0s-27.36 71.676 0 99.037l304.749 276.468-304.749 276.466c-27.36 27.359-27.36 71.676 0 99.036s71.677 27.36 99.037 0l354.531-321.606c14.783-14.783 21.302-34.538 20.084-53.897 1.186-19.36-5.301-39.114-20.084-53.898z" }, null, -1), F = [
  q
];
function H(t, i) {
  return n(), a("svg", j, F);
}
const U = /* @__PURE__ */ v(X, [["render", H]]), D = {}, G = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512.002 512.002"
}, J = /* @__PURE__ */ u("path", { d: "M511.267 197.258a14.995 14.995 0 00-12.107-10.209l-158.723-23.065-70.985-143.827a14.998 14.998 0 00-26.901 0l-70.988 143.827-158.72 23.065a14.998 14.998 0 00-8.312 25.585l114.848 111.954-27.108 158.083a14.999 14.999 0 0021.763 15.812l141.967-74.638 141.961 74.637a15 15 0 0021.766-15.813l-27.117-158.081 114.861-111.955a14.994 14.994 0 003.795-15.375z" }, null, -1), K = [
  J
];
function P(t, i) {
  return n(), a("svg", G, K);
}
const x = /* @__PURE__ */ v(D, [["render", P]]), Q = { class: "vue3-star-ratings__wrapper" }, T = { class: "vue3-star-ratings" }, Y = /* @__PURE__ */ R({
  __name: "Vue3StarRatings",
  props: {
    modelValue: null,
    starColor: { default: "#ff9800" },
    inactiveColor: { default: "#333333" },
    starSize: { default: "32" },
    controlBg: { default: "#2e5090" },
    controlColor: { default: "#fff" },
    controlSize: { default: "32" },
    numberOfStars: { default: 5 },
    showControl: { type: Boolean, default: !0 },
    disableClick: { type: Boolean, default: !1 },
    step: { default: 0.5 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    const o = t, r = _(o.modelValue || 0);
    function g(e, c) {
      const s = 10 ** c;
      return Math.round(e * s) / s;
    }
    function d(e) {
      return {
        width: `${e}px`,
        height: `${e}px`
      };
    }
    function $() {
      const e = o.numberOfStars, c = r.value + o.step;
      r.value = c >= e ? e : c;
    }
    function B() {
      const e = r.value - o.step;
      r.value = e <= 0 ? 0 : e;
    }
    const h = w(() => g(r.value, 1)), z = w(() => h.value / o.numberOfStars * 100 + "%"), f = _();
    function m(e) {
      const c = e.pageX - this.offsetLeft, s = o.numberOfStars;
      r.value = c / this.offsetWidth * s;
    }
    return V(() => {
      f.value && f.value.addEventListener("click", m);
    }), O(() => {
      f.value && f.value.removeEventListener("click", m);
    }), L(h, (e) => {
      i("update:modelValue", e);
    }), (e, c) => (n(), a("div", Q, [
      u("div", T, [
        t.showControl ? (n(), a("button", {
          key: 0,
          style: l({
            ...d(t.controlSize),
            backgroundColor: t.controlBg,
            color: t.controlColor
          }),
          onClick: B
        }, [
          y(W, {
            style: l({
              ...d(+t.controlSize - 16)
            })
          }, null, 8, ["style"])
        ], 4)) : S("", !0),
        u("div", {
          class: "stars",
          ref_key: "starsContainer",
          ref: f,
          style: l({ pointerEvents: t.disableClick ? "none" : "auto" })
        }, [
          u("div", {
            class: "stars-outer",
            style: l({ color: t.inactiveColor })
          }, [
            (n(!0), a(C, null, k(t.numberOfStars, (s) => (n(), b(x, {
              key: s,
              style: l({
                ...d(t.starSize)
              })
            }, null, 8, ["style"]))), 128))
          ], 4),
          u("div", {
            class: "stars-inner",
            style: l({ width: E(z), color: t.starColor })
          }, [
            (n(!0), a(C, null, k(t.numberOfStars, (s) => (n(), b(x, {
              key: s,
              style: l({
                ...d(t.starSize)
              })
            }, null, 8, ["style"]))), 128))
          ], 4)
        ], 4),
        t.showControl ? (n(), a("button", {
          key: 1,
          style: l({
            ...d(t.controlSize),
            backgroundColor: t.controlBg,
            color: t.controlColor
          }),
          onClick: $
        }, [
          y(U, {
            style: l({
              ...d(+t.controlSize - 16)
            })
          }, null, 8, ["style"])
        ], 4)) : S("", !0)
      ])
    ]));
  }
});
const tt = /* @__PURE__ */ v(Y, [["__scopeId", "data-v-786b615e"]]);
export {
  tt as default
};
